module.exports = __webpack_public_path__ + "assets/img/Fotolia_124669614_XS.c585f81d.jpg";